import { useContext } from "react";

import BusinessContext from "contexts/BusinessContext";

const useMenus = () => ({
	menus: useContext(BusinessContext).business.menus
});

export default useMenus;
